import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useMemo, useState } from 'react';
// Why DOES THIS NOT WORK??? We need to fix this in a configuration somewhere
// import { LoadingOverlay } from '../components';
import LoadingOverlay from '../components/LoadingOverlay';
export const loadingOverlayContext = createContext({
    openState: [false, (() => { })],
    modalState: [false, (() => { })],
    backdropMessageState: ['', (() => { })]
});
function LoadingOverlayProvider({ children }) {
    const [open, setOpen] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [backdropMessage, setBackdropMessage] = useState('');
    const currentState = useMemo(() => ({
        openState: [open, setOpen],
        modalState: [modalOpen, setModalOpen],
        backdropMessageState: [backdropMessage, setBackdropMessage]
    }), [open, modalOpen, backdropMessage]);
    return (_jsxs(loadingOverlayContext.Provider, { value: currentState, children: [_jsx(LoadingOverlay, {}), children] }));
}
export default LoadingOverlayProvider;
